import { IonButton, IonModal } from "@ionic/react";
import React, { useEffect, useState } from "react";
import { CONSTANTS } from "../../../constants/callcentral.constants";
import "./ReminderAlert.scss";

interface ContainerProps {
  // showReminderAlert: boolean;
  // showAlert: () => void;
  reminderInputParams: any;
  reminderList:any;
}
const ReminderAlert: React.FC<ContainerProps> = (props: any) => {
  const [audio, setAudio] = useState(
    new Audio(CONSTANTS.REMINDER_RINGTONE.PATH)
  );
  const [showModalAlert, setShowModalAlert] = useState(false);
  const [intervelID,setIntervalID] = useState<any>()

  useEffect(() => {
    if (props?.reminderInputParams?.id) {
      displayReminderAlert();
    }
  }, [props.reminderList]);

  const displayReminderAlert = () => {
    const intervalId = setInterval(() => {
      audio.load();
      audio.loop = true;
      audio.play();
      setShowModalAlert(true);
    }, 10000);
    setIntervalID(intervalId)
  };

  const hideReminderAlert = () => {
    clearInterval(intervelID);
    audio.load();
    audio.loop = false;
    audio.pause();
    setShowModalAlert(false);
  };

  const handleCancel = () =>{
    setShowModalAlert(false)
    audio.load();
    audio.loop = false;
    audio.pause();
  }

  return (
    <IonModal
      isOpen={showModalAlert}
      className="alert-modal"
      backdropDismiss={false}
    >
      <div className="alert-main-container">
        <div className="content-area">
          <h3 className="label">Reminder Alert</h3>
          <div className="room">
            <span>Bed No : </span>
            <span className="room-number">
              {props.reminderInputParams && props.reminderInputParams.bedName
                ? props.reminderInputParams.bedName
                : ""}
            </span>
          </div>
          <div className="reminder-message">
            {props.reminderInputParams && props.reminderInputParams.title
              ? props.reminderInputParams.title
              : ""}
          </div>
        </div>

        <div className="alert-button-container">
          <div className="cancel-button-div">
            <IonButton
              color="medium"
              className="cancel-button secondary-btn button btn-curved"
              onClick={handleCancel}
            >
              {t("cancel")}
            </IonButton>
          </div>
          <div className="send-button-div">
            <IonButton
              className="submit-btn button primary-btn btn-curved"
              onClick={() => {
                hideReminderAlert();
              }}
            >
              Ok
            </IonButton>
          </div>
        </div>
      </div>
    </IonModal>
  );
};

export default ReminderAlert;
